import { componentNameValidationMixin } from '@descope-ui/common/components-mixins';
import { createBaseClass } from '@descope-ui/common/base-classes';
import { getComponentName } from '@descope-ui/common/components-helpers';
import { compose } from '@descope-ui/common/utils';

// NOTICE: This component registers with a DIFFERENT name than its file name
export const componentName = getComponentName('ponyhot');

const HP_PREFIX = 'dhp-';

const BaseClass = createBaseClass({
  componentName,
  baseSelector: '',
});

class RawHoneypot extends BaseClass {
  get type() {
    return this.getAttribute('type');
  }

  get value() {
    return this.input?.value || '';
  }

  init() {
    this.input = this.querySelector('input');

    if (!this.input) return;

    this.#setupTrapListeners();
    this.#setupValueInterceptor();
    this.#hideComponent();
  }

  #setupTrapListeners() {
    const events = [
      'input',
      'change',
      'click',
      'keydown',
      'keyup',
      'mouseover',
      'mousedown',
    ];

    const fillHoneypot = (e) => {
      this.input.value = `${HP_PREFIX}${e.type}`;

      // Stop listening to all events after first trigger
      events.forEach((event) => {
        this.input.removeEventListener(event, fillHoneypot);
      });
    };

    events.forEach((event) => {
      this.input.addEventListener(event, fillHoneypot);
    });
  }

  // Intercept direct value assignments to catch bots that bypass events
  #setupValueInterceptor() {
    const originalDescriptor = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value',
    );

    Object.defineProperty(this.input, 'value', {
      get() {
        return originalDescriptor.get.call(this);
      },
      set(newValue) {
        const currentValue = originalDescriptor.get.call(this);

        // Only trap if the value is being set by external code (not our own trap)
        if (
          newValue &&
          !newValue.startsWith(HP_PREFIX) &&
          newValue !== currentValue
        ) {
          originalDescriptor.set.call(this, `${HP_PREFIX}direct-set`);
        } else {
          originalDescriptor.set.call(this, newValue);
        }
      },
      configurable: true,
    });
  }

  #hideComponent() {
    const styles = {
      position: 'absolute',
      opacity: '0.01',
      width: '1px',
      height: '1px',
      pointerEvents: 'none',
      zIndex: '-1',
      left: '-999999px',
    };

    Object.entries(styles).forEach(([key, value]) => {
      this.style[key] = value;
    });
  }
}

export const HoneypotClass = compose(componentNameValidationMixin)(RawHoneypot);
